import React, {useEffect, useRef, useState} from "react";
import {
    homeHippodrome,
    homeHippodromeSubject,
} from "../../store/misc.store";

import {ApiService} from "../../lib/http.service";
import {possiblesUrlPrefix} from "../../constants/global.vars";
import _ from "lodash";
import iconFather from "../../assets/feather/father-at-yarisi.svg";
import addCircle from "../../assets/feather/plus-circle.svg";
import {HippodromeWidget} from "../../shared/hippodrome/hippodrome";
import {useNavigate, useParams} from "react-router-dom";
import {useAvailableHippodromes, useDailyRaces} from "features/bulletin/bulletin.store";
import {Hippodrome} from "../../models/bulletin.models";
import {MutualBetslip, useMutualSlipOptions} from "../../features/betslip/mutual.service";
import {isMobile} from "../../App";
import iconClock from "../../assets/feather/clock.svg";
import loadingGif from "../../assets/img/loading.gif";
import paths from "../../paths";
import {MutualBetslipSidebar, MutualMobileBetslip} from "../betting/mutual.betting/mutual.betslip";
import {buildMutualBettingSubTypes, buildMutualBettingTypes, bulletinProvider} from "../../features/bulletin/bulletin.service";


let possibleInterval: any = null;

export function PossiblesPage() {
    const availableHippodromes = useAvailableHippodromes();
    const dailyRaces = useDailyRaces();
    const slipOptions = useMutualSlipOptions();

    const params: any = useParams();
    const [possiblesData, setPossiblesData] = useState<any>(null)
    const [selectedWagerIndex, setSelectedWagerIndex] = useState(1);
    const [hippodrome, setHippodrome] = useState<any>(homeHippodrome)
    const [shownRun, setShownRunState] = useState<any>(null);
    const shownRunRef = useRef<any>(null);
    const setShownRun = (r: any) => {
        shownRunRef.current = r;
        setShownRunState(r);
    };
    const navigate = useNavigate();

    const possibleMap: any = {
        "İKİLİ": 10,
        "SIRALI İKİLİ": 8,
        "ÇİFTE": 14,
    };

    useEffect(() => {

        let homeHippodromeSubject_subscription = homeHippodromeSubject.subscribe((res: any) => {
            try {
                setHippodrome(homeHippodrome);
                if (homeHippodrome.nextRun) {
                    setShownRun(homeHippodrome?.nextRun);
                } else {
                    setShownRun(homeHippodrome?.runs[0]);
                }
            } catch (e) {

            }

        })

        return () => {
            homeHippodromeSubject_subscription.unsubscribe();
        }

    }, []);


    useEffect(() => {
        if (params.hippodrome && availableHippodromes) {
            const _hippodrome = availableHippodromes.find((hippodrome: Hippodrome) => hippodrome.keyword.toLowerCase() + hippodrome._id.toLowerCase() === params.hippodrome.toLowerCase());

            Object.assign(homeHippodrome, _hippodrome);
            homeHippodromeSubject.next(_hippodrome);
            setHippodrome(_hippodrome);
            MutualBetslip.setOptions({hippodrome: _hippodrome});
        }
        getPossibles();

    }, [availableHippodromes.length]);

    const getPossibles = () => {
        if (window.location.pathname.includes('muhtemeller')) {
            let api = new ApiService()
            api.start("get", possiblesUrlPrefix, null, false).then((res: any) => {
                if (possibleInterval === null) {
                    possibleInterval = setInterval(getPossibles, 15000);
                }
                if (res.status) {
                    setPossiblesData(res.data);
                    if (shownRunRef.current == null) {
                        if (res.data && res.data.length > 0 && res.data[0].runs) {
                            if (hippodrome && params.run) {
                                try {
                                    let rn = hippodrome.runs.find((r: any) => Number(r.no) === Number(params.run))
                                    if (rn) {
                                        setShownRun(rn);
                                    } else {
                                        setShownRun(MutualBetslip.getOptions().hippodrome.runs[0]);
                                    }
                                } catch (e: any) {
                                    console.error(e);
                                    const _hippodrome = availableHippodromes.find((hippodrome: Hippodrome) => hippodrome.keyword.toLowerCase() === res.data[0].keyword.toLowerCase() && hippodrome._date === res.data[0]._date);
                                    if (_hippodrome) {
                                        setHippodrome(_hippodrome);
                                    }
                                    setShownRun(res.data[0].runs[0]);
                                }

                            } else {

                                const _hippodrome = availableHippodromes.find((hippodrome: Hippodrome) => hippodrome.keyword.toLowerCase() === res.data[0].keyword.toLowerCase() && hippodrome._date === res.data[0]._date);
                                if (_hippodrome) {
                                    setHippodrome(_hippodrome);
                                }
                                if (_hippodrome && _hippodrome.nextRun) {
                                    setShownRun(res.data[0].runs[_hippodrome.nextRun.no - 1]);
                                } else {
                                    setShownRun(res.data[0].runs[0]);
                                }

                            }
                        } else {
                            setShownRun(null);

                        }
                    }

                }
            });
        } else {
            clearInterval(possibleInterval);
            possibleInterval = null;
            setShownRun(null);
        }

    }

    const possibleSelection = (wager: any, wagerType: any) => {
        const bettingTypeId = possibleMap[wagerType];
        const run = hippodrome?.runsMap?.[Number(shownRun?.no)];
        const run2 = wagerType === 'ÇİFTE' ? hippodrome?.runsMap?.[Number(shownRun?.no) + 1] : run;
        if (!hippodrome?.status || bettingTypeId === undefined || run?.status !== 0 || !run2) {
            return null;
        }
        const bettingType = buildMutualBettingTypes(hippodrome).find((t: any) => Number(t.id) === bettingTypeId);
        const bettingSubType = buildMutualBettingSubTypes(bettingType).find((st: any) => Number(st.id) === Number(run.no));
        const horse1 = run.horseMap?.[wager.result1];
        const horse2 = run2.horseMap?.[wager.result2];
        if (!bettingType || !bettingSubType || !horse1?.run_status || !horse2?.run_status) {
            return null;
        }
        return {bettingType, bettingSubType, run, run2, horse1, horse2};
    }

    const addToTJKBetSlipFromPossible = (wager: any, wagerType: any) => {
        const selection = possibleSelection(wager, wagerType);
        if (!selection) {
            return;
        }
        MutualBetslip.setOptions({
            hippodrome: hippodrome,
            bettingType: selection.bettingType,
            bettingSubType: selection.bettingSubType,
            column: 1
        });
        MutualBetslip.clear();
        MutualBetslip.add(1, selection.run, selection.horse1, 'add');
        MutualBetslip.add(2, selection.run2, selection.horse2, 'add');
    }

    const colorHorses = (h1: any, h2: any) => {
        let allHorses: any = document.getElementsByClassName(`line`);
        let selectedWager: any = '';

        if (allHorses) {
            for (let e of allHorses) {
                e.classList.remove('high')
                e.classList.remove('low')
            }
        }
        if (h2 === null) {
            let firstHorses: any = document.getElementsByClassName(`first-horse-${h1}`)
            if (firstHorses) {
                for (let e of firstHorses) {
                    e.classList.add('high')
                }
            }

            let secondHorses: any = document.getElementsByClassName(`second-horse-${h1}`)

            if (secondHorses) {
                for (let e of secondHorses) {
                    if (!e.classList.contains('wager-cifte')) {
                        e.classList.add('low')
                    }

                }
            }

        } else {

            let firstHorses: any = document.getElementsByClassName(`first-horse-${h1} second-horse-null`)
            if (firstHorses) {
                for (let e of firstHorses) {
                    e.classList.add('high')
                }
            }

            let secondHorses: any = document.getElementsByClassName(`first-horse-${h2} second-horse-null`)
            if (secondHorses) {
                for (let e of secondHorses) {
                    if (!e.classList.contains('wager-cifte')) {
                        e.classList.add('low')
                    }
                }
            }

            let overHorses: any = document.getElementsByClassName(`first-horse-${h1} second-horse-${h2}`)
            if (overHorses) {
                for (let e of overHorses) {
                    e.classList.add('high')
                }
            }
        }
    }

    let eqStyles: any = {
        "1": {transform: 'scaleX(-1)', marginLeft: 5, filter: 'brightness(0)'},
        "2": {
            transform: 'scaleX(-1)',
            marginLeft: 5,
            filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(359deg) brightness(94%) contrast(117%)'
        },
        "3": {transform: 'scaleX(-1)', marginLeft: 5},
    }

    if (!hippodrome || !possiblesData) {
        return <>
            <HippodromeWidget hideProgramHippodrome={true}/>
            <div className="container ">
                <div className={"d-flex justify-content-center align-items-center w-100"}>
                    <img src={loadingGif}/>
                </div>
            </div>
        </>
    }

    if (possiblesData.length === 0) {
        return <>
            <HippodromeWidget hideProgramHippodrome={true}/>
            <div className="container ">
                <p className="p-4 text-center"><img alt={"clock"} src={iconClock} width={64}/> <br/><br/>
                    Henüz Muhtemeller verileri açıklanmamış olabilir lütfen kısa bir süre sonra tekrar deneyiniz.</p>
            </div>
        </>
    }


    let possibles: any = possiblesData.find((el: any) => el.keyword === hippodrome.keyword)?.runs?.find((p: any) => p.no === shownRun?.no)


    if (isMobile) {
        return (
            <>
                <div className={`${''}`}>
                    <select onChange={(e: any) => {
                        var _hippodrome = dailyRaces.find((hippodrome: any) => hippodrome.keyword + hippodrome._id === e.target.value);
                        Object.assign(homeHippodrome, _hippodrome);
                        homeHippodromeSubject.next(_hippodrome);
                        setHippodrome(_hippodrome);
                        MutualBetslip.setOptions({hippodrome: _hippodrome});
                        navigate(`${paths.possibles.url}/${(e.target.value).toLowerCase()}`);
                    }} value={MutualBetslip.getOptions()?.hippodrome?.keyword + MutualBetslip.getOptions()?.hippodrome?._id}
                            className={"betting-select w-100"}>
                        {dailyRaces.map((hippodrome: any, keyHippodrome: number) => {
                            if (hippodrome.keyword === 'KARMA') return;

                            return (
                                <option
                                    key={`keyBettingType-${keyHippodrome}`}
                                    value={hippodrome.keyword + hippodrome._id}>
                                    {hippodrome.hippodrome}
                                </option>
                            )
                        })}
                    </select>
                </div>

                <div className={`container p-0`}>
                    <div className={"table-wrapper"} style={{marginBottom: '150px'}}>
                        {hippodrome.runs && <div className={"run-tabs possibles-run-wrapper"}>
                            {hippodrome.runs.map((run: any, keyRun: number) => {
                                return (
                                    <div key={`runItem-${keyRun}`}
                                         className={`run-tab-item d-flex ${shownRun?.no === run.no ? 'active flex-column' : ''}`}
                                         onClick={() => {
                                             setShownRun(run);
                                             try {
                                                 // @ts-ignore
                                                 dataLayer.push({
                                                     event: "muhtemeller_click",
                                                     area_page: "Muhtemeller",
                                                     hippodrome: hippodrome.hippodrome,
                                                     kosu_type: shownRun.no.toString()
                                                 });
                                             } catch (e) {

                                             }

                                         }}>
                                        <div className={"d-flex justify-content-between align-items-center w-100"}>
                                            <p className={"text-small"}>{run.no}{shownRun?.no === run.no && ". Koşu"}</p>
                                            {shownRun?.no === run.no && <span className="possible-badge">0</span>}
                                        </div>
                                        {shownRun?.no === run.no &&
                                            <div className={"d-flex justify-content-between align-items-center w-100"}>
                                                <div className={"run-tab-selected-info"}>{shownRun.course}</div>
                                                <div
                                                    className={"run-tab-selected-info fw-regular"}>{shownRun.distance}m {shownRun.group_short}</div>
                                            </div>}


                                    </div>)
                            })}
                        </div>}

                        {possibles && possibles.wagers && possibles.wagers.length > 0 && isMobile &&
                            <div className={""} style={{backgroundColor: "#1F3735"}}>
                                <div className={"d-flex justify-content-center align-items-center"}>
                                    {
                                        possibles.wagers.map((wager: any, key: any) => {
                                            if (wager.wager != 'GANYAN') {
                                                return <>
                                <span onClick={() => {
                                    setSelectedWagerIndex(key);
                                }}
                                      id={"pill-tab"}
                                      className={`pill-tab text-center ${key === 1 ? 'left' : ''} ${key === possibles.wagers.length - 1 ? 'right' : ''} ${selectedWagerIndex === key ? 'active' : ''}`}>{wager.wager}</span>
                                                </>
                                            }

                                        })
                                    }
                                </div>

                            </div>}
                        {possibles && possibles.wagers && possibles.wagers.length > 0 && isMobile &&
                            <div className={"w-100 d-inline-flex flex-nowrap possibles-table"}>

                                {possibles.wagers?.map((r: any, key: number) => {
                                    if (r.wager === 'GANYAN' || key === selectedWagerIndex) {
                                        return (
                                            <div className={`${r.wager === "GANYAN" ? 'col' : 'col-4'} runs`}
                                                 key={`agf-runs-r-${key}`}>
                                                <div className="caption">
                                                    {r.wager}
                                                </div>
                                                {r.possibilities.map((p: any, pkey: number) => {
                                                    let minGanyan = _.orderBy(r.possibilities, [(a: any) => Number(a.ganyan)], ['asc'])[0]
                                                    return (<div className={`
                                        ${key === 0 ? 'line' : 'line'} 
                                        ${key === 0 && Number(minGanyan.ganyan) === Number(p.ganyan) ? 'fw-bold text-success' : ''} 
                                        first-horse-${p.result1} 
                                        second-horse-${p.result2} 
                                        p-1 p-lg-2 d-flex `} onMouseOver={() => {
                                                        colorHorses(p.result1, p.result2)
                                                    }} key={`possibilities-${pkey}`}
                                                                 onClick={() => addToTJKBetSlipFromPossible(p, r.wager)}>

                                                    <span
                                                        className={"text-xxsmall"}>{p.result1} - {r.wager === 'GANYAN' ? p.horse_name : ''} {key !== 0 && <> {p.result2}</>}
                                                        {key === 0 && ["1", "2", "3"].includes(p.stablemate) ?
                                                            <img alt={"iconFather"} src={iconFather}
                                                                 style={eqStyles[p.stablemate]}/> : null}
                                                    </span>

                                                        <span
                                                            className={"text-xxsmall  text-bold"}> &nbsp; {p.ganyan === '-' ? (isMobile ? 'K' : 'KOŞMAZ') : p.ganyan}</span>
                                                        {}
                                                        {possibleSelection(p, r.wager) &&
                                                            <img className={"invert-color"} src={addCircle}
                                                                 width={16}/>}

                                                    </div>)
                                                })}
                                            </div>
                                        )
                                    }
                                })}
                            </div>}

                    </div>
                </div>
                {slipOptions.bettingSubType &&
                    <MutualMobileBetslip/>}

            </>
        )
    }

    return (
        <>
            <HippodromeWidget hideProgramHippodrome={true} hideKarma={true}/>

            <div className={`container ${isMobile ? 'p-0' : ''}`}>
                <div className={"table-wrapper mt-2"} style={{marginBottom: '150px'}}>
                    {hippodrome.runs && <div className={"run-tabs possibles-run-wrapper"}>
                        {hippodrome.runs.map((run: any, keyRun: number) => {
                            return (
                                <div key={`runItem-${keyRun}`}
                                     className={`run-tab-item ${shownRun?.no === run.no ? 'active' : ''}`}
                                     onClick={() => {
                                         setShownRun(run);
                                         try {
                                             // @ts-ignore
                                             dataLayer.push({
                                                 event: "muhtemeller_click",
                                                 area_page: "Muhtemeller",
                                                 hippodrome: hippodrome.hippodrome,
                                                 kosu_type: shownRun.no.toString()
                                             });
                                         } catch (e) {

                                         }

                                     }}>
                                    <p className={"text-small text-white text-bolder"}>{run.no}.</p>
                                    <p className={"text-xsmall text-white"}>Koşu</p>

                                </div>)
                        })}
                    </div>}

                    {possibles && possibles.wagers && possibles.wagers.length > 0 && !isMobile &&
                        <div className={"w-100 d-inline-flex flex-nowrap possibles-table"}>
                            {possibles.wagers?.map((r: any, key: number) => {
                                return (
                                    <div className="col runs" key={`agf-runs-r-${key}`}>
                                        <div className="caption">
                                            {r.wager}
                                        </div>
                                        {r.possibilities.map((p: any, pkey: number) => {
                                            let minGanyan = _.orderBy(r.possibilities, [(a: any) => Number(a.ganyan)], ['asc'])[0]
                                            return (<div className={`
                                        ${key === 0 ? 'line' : 'line'} 
                                        ${key === 0 && Number(minGanyan.ganyan) === Number(p.ganyan) ? 'fw-bold text-success' : ''} 
                                        first-horse-${p.result1} 
                                        second-horse-${p.result2} 
                                        wager-${r.wager.replaceAll('İ', 'I').replaceAll('Ç', 'C').toLowerCase()}
                                        d-flex justify-content-start`} style={{padding: isMobile ? "12px 5px" : "12px", cursor: possibleSelection(p, r.wager) ? "pointer" : undefined}}
                                                         onMouseOver={() => {
                                                             colorHorses(p.result1, p.result2)
                                                         }} onClick={() => addToTJKBetSlipFromPossible(p, r.wager)}
                                                         key={`possibilities-${pkey}`}>
                                                <div className="w-100">
                                                    <div className="text-xxsmall possible-horse-name">
                                                        <div className="d-flex">
                                                        <span
                                                            className={`possible-horse-name ${key === 0 && Number(minGanyan.ganyan) === Number(p.ganyan) ? 'text-success' : ''} `}
                                                            style={{margin: "auto"}}> {p.result1}{key !== 0 && <> - {p.result2}</>} {!isMobile && p.horse_name}  </span>
                                                            {key === 0 && ["1", "2", "3"].includes(p.stablemate) ?
                                                                <img alt={"iconFather"} width={"11"} height={"11"}
                                                                     src={iconFather}
                                                                     style={eqStyles[p.stablemate]}/> : null}
                                                            {p.ganyan === '-' &&
                                                                <span className=" ms-1 items-items-center d-flex"
                                                                      style={{margin: "auto"}}>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg" width="16"
                                                                height="16"
                                                                viewBox="0 0 16 16" fill="none">
                                                                <g clipPath="url(#clip0_7388_54912)">
                                                                    <path
                                                                        d="M5.21362 10.7067C3.97829 8.84351 4.85022 7.38868 4.85022 7.38868C4.64738 7.32743 4 7.76084 4 7.76084C4.36397 6.39584 6.36725 5.23676 6.36725 5.23676C6.14499 5.15334 5.5176 5.31843 5.5176 5.31843C7.15691 3.70668 9.16019 4.30634 9.16019 4.30634C9.22076 3.95401 10.2127 3.33334 10.2127 3.33334C10.111 3.43601 10.0698 3.99543 10.0698 3.99543C10.1721 3.80876 10.4967 3.62268 10.4967 3.62268C10.3144 4.05668 10.4967 4.98768 10.4967 4.98768C11.0223 5.52609 11.6092 7.38868 11.6092 7.38868L11.832 7.71943C12.116 8.13359 12.0114 8.78518 11.7309 8.93976C10.6789 9.52076 10.5767 8.46434 10.5767 8.46434C9.70701 8.36109 9.05906 7.36768 9.05906 7.36768C7.886 7.98776 8.53909 9.73893 9.04591 10.4109C9.69672 11.2725 9.21962 12.6667 9.21962 12.6667C9.21962 12.6667 6.43296 12.5488 5.21362 10.7067Z"
                                                                        fill="#353535">
                                                                    </path>
                                                                    <path
                                                                        d="M3.28634 3.28668L12.713 12.7133M14.6663 8.00001C14.6663 11.6819 11.6816 14.6667 7.99967 14.6667C4.31778 14.6667 1.33301 11.6819 1.33301 8.00001C1.33301 4.31811 4.31778 1.33334 7.99967 1.33334C11.6816 1.33334 14.6663 4.31811 14.6663 8.00001Z"
                                                                        stroke="#E04C4C" strokeWidth="1.33333"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round">
                                                                    </path>
                                                                </g>
                                                            </svg>
                                                        </span>}
                                                        </div>
                                                        <span
                                                            className={`text-xxsmall text-bold  possible-horse-name ${p.ganyan == '-' ? 'text-danger' : ''}  ${key === 0 && Number(minGanyan.ganyan) === Number(p.ganyan) ? 'text-success' : ''} `}
                                                            style={{margin: "auto 0px"}}>{p.ganyan == '-' ? 'Koşmaz' : p.ganyan}</span>
                                                        {possibleSelection(p, r.wager) &&
                                                            <img className={"ms-1"} src={addCircle} width={14}
                                                                 style={{margin: "auto 0px"}}/>}
                                                    </div>
                                                </div>
                                            </div>)
                                        })}
                                    </div>
                                )
                            })}
                        </div>}
                    {possibles && possibles.wagers && possibles.wagers.length > 0 && isMobile &&
                        <div className={"px-2 py-2"} style={{backgroundColor: "#1F3735"}}>
                            <div className={"d-flex justify-content-center align-items-center"}>
                                {
                                    possibles.wagers.map((wager: any, key: any) => {
                                        if (wager.wager != 'GANYAN') {
                                            return <>
                                <span onClick={() => {
                                    setSelectedWagerIndex(key);
                                }}
                                      id={"pill-tab"}
                                      className={`pill-tab text-center ${key === 1 ? 'left' : ''} ${key === possibles.wagers.length - 1 ? 'right' : ''} ${selectedWagerIndex === key ? 'active' : ''}`}>{wager.wager}</span>
                                            </>
                                        }

                                    })
                                }
                            </div>

                        </div>}
                    {possibles && possibles.wagers && possibles.wagers.length > 0 && isMobile &&
                        <div className={"w-100 d-inline-flex flex-nowrap possibles-table"}>

                            {possibles.wagers?.map((r: any, key: number) => {
                                if (r.wager === 'GANYAN' || key === selectedWagerIndex) {
                                    return (
                                        <div className={`${r.wager === "GANYAN" ? 'col' : 'col-4'} runs`}
                                             key={`agf-runs-r-${key}`}>
                                            <div className="caption">
                                                {r.wager}
                                            </div>
                                            {r.possibilities.map((p: any, pkey: number) => {
                                                let minGanyan = _.orderBy(r.possibilities, [(a: any) => Number(a.ganyan)], ['asc'])[0]
                                                return (<div className={`
                                        ${key === 0 ? 'line' : 'line'} 
                                        ${key === 0 && Number(minGanyan.ganyan) === Number(p.ganyan) ? 'fw-bold text-success' : ''} 
                                        first-horse-${p.result1} 
                                        second-horse-${p.result2} 
                                        p-1 p-lg-2 d-flex `} onMouseOver={() => {
                                                    colorHorses(p.result1, p.result2)
                                                }} key={`possibilities-${pkey}`}>

                                        <span
                                            className={"text-xxsmall"}>{p.result1} - {r.wager === 'GANYAN' ? p.horse_name : ''} {key !== 0 && <> {p.result2}</>}
                                            {key === 0 && ["1", "2", "3"].includes(p.stablemate) ?
                                                <img alt={"iconFather"} src={iconFather}
                                                     style={eqStyles[p.stablemate]}/> : null}
                                        </span>

                                                    <span
                                                        className={"text-xxsmall  text-bold"}> &nbsp; {p.ganyan === '-' ? (isMobile ? 'K' : 'KOŞMAZ') : p.ganyan}</span>

                                                </div>)
                                            })}
                                        </div>
                                    )
                                }
                            })}
                        </div>}

                </div>
            </div>
            {slipOptions.bettingSubType && slipOptions.bettingType?.id !== 0 && <MutualBetslipSidebar/>}
        </>
    )
}
